export enum BillStatus {
  Open = "open",
  Closed = "closed",
  Paid = "paid",
  Void = "void",
  Failed = "failed",
  Refunded = "refunded",
  PartiallyRefunded = "partially_refunded",
}
